import { useState } from 'react'
import type { Mode } from '../components/metrics/types'
import { ModeToggle } from '../components/metrics/ModeToggle'
import { AiAnalysisPanel } from '../components/metrics/AiAnalysisPanel'
import { EndpointsProbe } from '../components/metrics/EndpointsProbe'
import { PipelineDashboard } from '../components/metrics/PipelineDashboard'
import { ReadershipDashboard } from '../components/metrics/ReadershipDashboard'

export default function MetricsPage() {
  const [mode, setMode] = useState<Mode>('ai')

  return (
    <div className="relative">
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-56"
        style={{ background: 'linear-gradient(to bottom, var(--violet-4), var(--violet-2), transparent)', opacity: 0.5 }}
      />

      <div className="relative px-6 pt-5">
        <div className="flex items-center justify-between border-b border-line pb-4">
          <h1 className="font-zodiak pl-8 text-3xl font-bold text-fg">Metrics</h1>
          <ModeToggle mode={mode} onChange={setMode} />
        </div>
      </div>

      <div className="relative mx-auto max-w-5xl px-8 py-8">
        {mode === 'ai' && <AiAnalysisPanel />}
        {mode === 'pipeline' && <PipelineDashboard />}
        {mode === 'readership' && <ReadershipDashboard />}
        {mode === 'endpoints' && <EndpointsProbe />}
      </div>
    </div>
  )
}
